const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getDataAllTeacher({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}/teachers?search=${payload.search}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getDataAllStudent({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}/students?search=${payload.search}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  inviteTeacher({ commit }, payload) {
    return window.axios.post(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}/invite?email=${payload.email}`);
  },
  // eslint-disable-next-line no-unused-vars
  async inviteTeacherCheck({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}/information?email=${payload.email}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
